export default __webpack_public_path__ + "ac0c240332d744f84c5646b695131553.png";